<div mat-dialog-title>
  Edit roster
</div>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab [label]="broadcast.config.awayConfig.fullName">
      <ng-container *ngTemplateOutlet="rosterTab; context: {roster: awayRoster, teamId: awayTeamId}"></ng-container>
    </mat-tab>
    <mat-tab [label]="broadcast.config.homeConfig.fullName">
      <ng-container *ngTemplateOutlet="rosterTab; context: {roster: homeRoster, teamId: homeTeamId}"></ng-container>
    </mat-tab>
    <mat-tab label="Other">
      <ng-container *ngTemplateOutlet="otherTab"></ng-container>
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <button mat-flat-button (click)="close()">
    Close
  </button>
  <button mat-flat-button color="primary" (click)="update()" cdkFocusInitial>
    <mat-icon>done</mat-icon>
    Update
  </button>
</div>

<ng-template #rosterTab let-roster="roster" let-teamId="teamId">
  <div class="roster-container">
    <table class="roster-table">
      <thead>
        <tr>
          <th class="number-col">Number</th>
          <th>Name</th>
          <th class="actions-col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let player of roster; let i = index" class="roster-row">
          <td class="number-col">
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="number-field">
              <input matInput type="number" [(ngModel)]="player.number" placeholder="#">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="name-field">
              <input matInput type="text" [(ngModel)]="player.name" placeholder="Player name">
            </mat-form-field>
          </td>
          <td class="actions-col">
            <button mat-icon-button class="delete-btn" *ngIf="!player.guid" (click)="removePlayer(roster, i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button mat-stroked-button color="primary" (click)="addPlayer(roster, teamId)">
      <mat-icon>add</mat-icon> Add player
    </button>
  </div>
</ng-template>

<ng-template #otherTab>
  <div class="roster-container">
    <table class="roster-table">
      <thead>
        <tr>
          <th>Name/Title</th>
          <th>Infoline</th>
          <th class="actions-col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let person of otherPlayers; let i = index" class="roster-row">
          <td>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="name-field">
              <input matInput type="text" [(ngModel)]="person.name" placeholder="Name/Title">
            </mat-form-field>
          </td>
          <td>
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="name-field">
              <input matInput type="text" [(ngModel)]="person.info" placeholder="Infoline">
            </mat-form-field>
          </td>
          <td class="actions-col">
            <button mat-icon-button class="delete-btn" *ngIf="!person.guid" (click)="removePlayer(otherPlayers, i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button mat-stroked-button color="primary" (click)="addOther()">
      <mat-icon>add</mat-icon> Add person
    </button>
  </div>
</ng-template>
